import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCheck = () => {
  return (
    <g>
      <path d="M14.716 2.226a.747.747 0 0 1 1.06-.01.757.757 0 0 1 .082.98l-.072.086-10.25 10.492a.747.747 0 0 1-.98.079l-.085-.074L.224 9.51a.757.757 0 0 1 0-1.066.747.747 0 0 1 .976-.073l.084.073 3.712 3.732 9.72-9.95z" />
    </g>
  );
};

export default withIcon(IconCheck);
